/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourtSummary
 */
export interface CourtSummary {
    /**
     * 
     * @type {string}
     * @memberof CourtSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourtSummary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CourtSummary
     */
    venueId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourtSummary
     */
    venueName?: string;
}

/**
 * Check if a given object implements the CourtSummary interface.
 */
export function instanceOfCourtSummary(value: object): value is CourtSummary {
    return true;
}

export function CourtSummaryFromJSON(json: any): CourtSummary {
    return CourtSummaryFromJSONTyped(json, false);
}

export function CourtSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'venueId': json['venueId'] == null ? undefined : json['venueId'],
        'venueName': json['venueName'] == null ? undefined : json['venueName'],
    };
}

export function CourtSummaryToJSON(json: any): CourtSummary {
    return CourtSummaryToJSONTyped(json, false);
}

export function CourtSummaryToJSONTyped(value?: CourtSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'venueId': value['venueId'],
        'venueName': value['venueName'],
    };
}

